import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsSets, setFont } from "@similarweb/styles";

import { percents } from "../../../pages/app performance/src/page/single/usage section/formatters";

import { NumberCell } from "./NumberCell";

const green = colorsSets.verdics["green s100"];
const red = colorsSets.verdics["red s100"];
const StyledIcon = styled(SWReactIcons)`
    margin-right: 6px;
    display: flex;
`;

const ArrowUp = ({ className = undefined }: { className?: string }) => {
    return (
        <StyledIcon
            className={className}
            iconName="arrow-up"
        />
    );
};

const ArrowDown = ({ className = undefined }: { className?: string }) => {
    return (
        <StyledIcon
            className={className}
            iconName="arrow-down"
        />
    );
};

const ChangeCellStyled = styled(NumberCell)`
    display: flex;
    align-items: center;
    ${setFont({ $family: "'Roboto'", $size: 14 })};
`;

const PositiveChange = styled(ChangeCellStyled)`
    color: ${green};
    ${StyledIcon} {
        path {
            fill: ${green};
        }
    }
`;

const NegativeChange = styled(ChangeCellStyled)`
    color: ${red};
    ${StyledIcon} {
        path {
            fill: ${red};
        }
    }
`;

export const ChangeCell = ({ value }: { value: number | null }) => {
    if (typeof value !== "number") {
        return <ChangeCellStyled>--</ChangeCellStyled>;
    }
    if (value > 0) {
        return (
            <PositiveChange>
                <ArrowUp />
                {percents({ value })}
            </PositiveChange>
        );
    } else if (value < 0) {
        return (
            <NegativeChange>
                <ArrowDown />
                {percents({ value })}
            </NegativeChange>
        );
    } else if (value == 0) {
        return <ChangeCellStyled>0</ChangeCellStyled>;
    }
};
